// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-members__new-button {
    background: var(--white-color);
    border-radius: 2px;
}

.page-members__container {
    margin-top: var(--space);
}
.page-members__members__member {
    margin-bottom: var(--space-half);
}

/* Show user styles */

.page-members__members {
    display: flex;    
    align-items: center;   
    margin-bottom: var(--space);
}
.page-members__photo {
    width: calc(var(--space-x2) + var(--space-half));
    height: calc(var(--space-x2) + var(--space-half));
    min-width: var(--space-x2);
    min-height: var(--space-x2);
    position: relative;
    border-radius: calc(var(--space-x2) + var(--space-half));
    overflow: hidden;
    margin-right: var(--space);
    background: var(--primary-light-color);
    padding: var(--space-quarter);
}
.page-members__photo:hover {
    cursor: pointer;
}
.page-members__photo img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.page-members__photo.no-photo img {
    position: relative;
}
.page-members__info {
    max-height: var(--space-x2);
    flex-grow: 1;
}

.page-members__info__username:hover {
    cursor: pointer;
}

.page-members__options {
    display: flex;
    margin-left: var(--space);
}
.page-members__options__option {
    width: var(--space-and-half);
    height: var(--space-and-half);
    display: flex;
    justify-content: center;
    align-items: center;
}
.page-members__options__option img {
    width: 100%;
    height: 100%;
}
.page-members__options__option:hover {
    cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-members/PageMembersComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,gCAAgC;AACpC;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,gDAAgD;IAChD,iDAAiD;IACjD,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,wDAAwD;IACxD,gBAAgB;IAChB,0BAA0B;IAC1B,sCAAsC;IACtC,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;AACnB","sourcesContent":[".page-members__new-button {\n    background: var(--white-color);\n    border-radius: 2px;\n}\n\n.page-members__container {\n    margin-top: var(--space);\n}\n.page-members__members__member {\n    margin-bottom: var(--space-half);\n}\n\n/* Show user styles */\n\n.page-members__members {\n    display: flex;    \n    align-items: center;   \n    margin-bottom: var(--space);\n}\n.page-members__photo {\n    width: calc(var(--space-x2) + var(--space-half));\n    height: calc(var(--space-x2) + var(--space-half));\n    min-width: var(--space-x2);\n    min-height: var(--space-x2);\n    position: relative;\n    border-radius: calc(var(--space-x2) + var(--space-half));\n    overflow: hidden;\n    margin-right: var(--space);\n    background: var(--primary-light-color);\n    padding: var(--space-quarter);\n}\n.page-members__photo:hover {\n    cursor: pointer;\n}\n.page-members__photo img {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n.page-members__photo.no-photo img {\n    position: relative;\n}\n.page-members__info {\n    max-height: var(--space-x2);\n    flex-grow: 1;\n}\n\n.page-members__info__username:hover {\n    cursor: pointer;\n}\n\n.page-members__options {\n    display: flex;\n    margin-left: var(--space);\n}\n.page-members__options__option {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.page-members__options__option img {\n    width: 100%;\n    height: 100%;\n}\n.page-members__options__option:hover {\n    cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
